import { Component }                 from '@angular/core';
import { Organization }              from '@app/modules/organization/models/organization.model';
import { OrganizationService }       from '@app/modules/organization/services/organization.service';
import {
	IBaseHttpParams,
	RequestCompleteListState
}                                    from '@core/interfaces/api.interface';
import { SelectFilterBaseComponent } from '@shared/list-operations/components/select-filters/select-filter-base/select-filter-base.component';
import { ISelectFilterable }         from '@shared/list-operations/model/filter.model';
import { Observable }                from 'rxjs';

@Component( {
	selector: 'app-select-filter-organization',
	templateUrl: './../select-filter-base/select-filter-base.component.html'
} )
export class SelectFilterOrganizationComponent extends SelectFilterBaseComponent implements ISelectFilterable {

	constructor(
		private readonly organizationService: OrganizationService
	) {
		super();
	}

	searchRequestCallback = ( searchRequestParams: IBaseHttpParams ): Observable<RequestCompleteListState<Organization>> => {

		switch ( this.defaultFilterData?.selectFilter?.presetId ) {

			default:
				return this.organizationService.search(
					searchRequestParams,
					'SelectFilterOrganizationComponent:searchRequestCallback',
					{ updateStore: false }
				);
		}
	};
}
